import MealCard from '../components/meal-card';
import * as React from 'react';
import { createRef, RefObject, useEffect, useRef, useState } from 'react';
import '../components/shared.scss';
import OrderMobileButton from '../components/order-button-mobile';
import { Card, CardMedia, Skeleton } from '@mui/material';
import useCheckMobileScreen from '../utils/detect-mobile-size';
import CategoryBar from '../components/category-bar';
import ScrollToTopButton from '../utils/scroll-to-top-button';
import Header from '../components/header';
import Footer from '../components/footer';
import Sidebar from '../components/sidebar';
import data from '../Company.json';
import ICategory from '../interfaces/ICategory';
import IProduct from '../interfaces/IProduct';
import _ from 'lodash';
import { totalPrice } from '../utils/order-actions';
import IDelivery from '../interfaces/IDelivery';

export default function OrderPage() {
    const [categories, setCategories] = useState<Array<ICategory>>([]);
    const [deliveryOptions, setDeliveryOptions] = useState<IDelivery>({} as IDelivery);
    const [cart, setCart] = useState<IProduct[]>([]);
    const [drinks, setDrinks] = useState<IProduct[]>([]);

    const [isFiltering, setIsFiltering] = useState(false);
    const [searchCategories, setSearchCategories] = useState<Array<ICategory>>([]);

    const [isLoading, setIsLoading] = useState(false);

    let isMobile = useCheckMobileScreen();

    const addItem = (product: IProduct) => {
        setCart(oldArray => {
            let array = [...oldArray];
            const index = _.findIndex(array, _.omit(product, ['quantity']));

            if (_.isEqual(_.omit(array[index], ['quantity']), _.omit(product, ['quantity']))) {
                array[index].quantity += product.quantity = 0 ? 1 : product.quantity
            } else {
                array.push(product);
            }

            localStorage.setItem('savedOrder', JSON.stringify(array));
            return array;
        });
    }

    useEffect(() => {
        // @ts-ignore

        const savedItems = JSON.parse(localStorage.getItem('savedOrder'));
        if (savedItems) {
            setCart(savedItems);
        }
        // getAllMeals();

        if (isFiltering) {
            window.scrollTo({top: 0});
        }

        getCategories();
        getDeliveryData();
    }, [isFiltering, searchCategories]);

    const getCategories = () => {
        const getCategories = data.data.company.menus[0].categories as ICategory[];
        setCategories(getCategories);
        let getDrinks: IProduct[] = [];
        getCategories.map(cat => {
            if (cat.isDrinks) {
                cat.products.map(prod => {
                    getDrinks.push(prod);
                })
            }
        })

        setDrinks(getDrinks);
    }

    const getDeliveryData = () => {
        // @ts-ignore
        setDeliveryOptions(data.data.company.menus[0].delivery);
    }

    const filterProducts = (searchQuery = '') => {
        const newCat = categories.map(category => {
            const filteredProducts = category.products.filter(product => product.name.toLowerCase().includes(searchQuery.toLowerCase()));

            return {
                ...category,
                name: category.name,
                products: filteredProducts
            } as ICategory;
        });

        const newCatArray: ICategory[] = []
        newCat.map(cat => {
            if (cat.products.length > 0) {
                newCatArray.push(cat);
            }
        })
        setSearchCategories(newCatArray)
        setIsFiltering(true);
    }

    //TODO place in new component/file?
    const categoryTemplate = (category: ICategory) => {
        return (
            // @ts-ignore
            <div id={'category_' + category.id} className="category-section pb-0 md:pb-4"
                 key={category.id}>
                {!isMobile &&
                    <Card className="relative">
                        {category.headerImage &&
                            <CardMedia
                                component="img"
                                className="img-card"
                                sx={{height: 120}}
                                image={`${process.env.PUBLIC_URL}/assets/images/${category.headerImage}`}
                            />
                        }
                    </Card>
                }
                <h3 className="category-title pt-0 md:pt-2">{category.name}</h3>
                {category.restrictions.length > 0 &&
                    <p className="category-description py-2">
                        🕓 De producten in deze categorie kunnen alleen worden besteld tussen:
                        <span className="font-semibold">&nbsp;16:00 - 20:00</span>
                    </p>
                }
                <p className="category-description pb-4">{category.description}</p>

                <div className={'meal-grid ' + 'grid-col-' + category.gridColumns?.toString()}>
                    {isLoading ? [...Array(12)].map((e, i) => <Skeleton key={i} variant="rectangular"
                                                                        width="100%" height={140}/>)
                        :
                        category.products.length > 0 && category.products.map(product => <MealCard
                            category={category} setCart={setCart} cart={cart} isLoading={isLoading}
                            addItem={addItem} product={product} key={product.id}/>)
                    }
                </div>
            </div>
        )
    }

    return (
        <div className="flex w-full h-full bg-gray-50">
            <div className="relative w-full min-w-0">
                <Header/>
                <CategoryBar categories={categories} setIsFiltering={setIsFiltering} onSearch={filterProducts}/>
                <div className="order-page-layout">
                    {isFiltering ?
                        searchCategories.map((category) => categoryTemplate(category))
                        :
                        categories.map((category) => categoryTemplate(category))
                    }
                </div>

                <div className="top-button-container">
                    <ScrollToTopButton/>
                </div>
                <Footer/>
            </div>

            <Sidebar addItem={addItem} drinks={drinks} deliveryOptions={deliveryOptions}
                     totalPrice={totalPrice(cart, deliveryOptions)}
                     setCartState={setCart} cartItems={cart}/>
            <OrderMobileButton addItem={addItem} drinks={drinks} deliveryOptions={deliveryOptions}
                               totalPrice={totalPrice(cart, deliveryOptions)}
                               setCartState={setCart} cartItems={cart}/>
        </div>
    )

}
